import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.5",
  y: "0.5",
  width: "31",
  height: "31",
  rx: "3.5",
  stroke: "#E2E6E9"
}, null, -1)

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Filter2Icon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.0421 15.6321C13.0586 15.6468 13.0742 15.6605 13.0897 15.677C14.0788 16.6908 14.6242 18.0338 14.6242 19.4592V23.1112L16.6739 21.9947C16.8352 21.9067 16.9352 21.7343 16.9352 21.5446V19.4482C16.9352 18.0283 17.4751 16.6899 18.455 15.6816L22.8889 10.9653C23.1758 10.6601 23.3335 10.2595 23.3335 9.83692V8.97892C23.3335 8.55359 22.998 8.20801 22.5873 8.20801H8.95558C8.544 8.20801 8.2085 8.55359 8.2085 8.97892V9.83692C8.2085 10.2595 8.36616 10.6601 8.65308 10.9644L13.0421 15.6321ZM14.3007 24.7089C14.1155 24.7089 13.9322 24.6594 13.7653 24.5604C13.4427 24.3679 13.2492 24.0278 13.2492 23.6502V19.4592C13.2492 18.4188 12.8615 17.4388 12.1547 16.6881C12.1337 16.6707 12.1126 16.6514 12.0942 16.6313L7.65208 11.9077C7.12408 11.3467 6.8335 10.6106 6.8335 9.83692V8.97892C6.8335 7.79551 7.78591 6.83301 8.95558 6.83301H22.5873C23.7561 6.83301 24.7085 7.79551 24.7085 8.97892V9.83692C24.7085 10.6097 24.4179 11.3448 23.8917 11.9068L19.4487 16.6313C18.7126 17.3903 18.3102 18.3885 18.3102 19.4482V21.5446C18.3102 22.2376 17.9352 22.8719 17.3321 23.2019L14.8012 24.5806C14.6435 24.6658 14.4721 24.7089 14.3007 24.7089Z",
      fill: __props.color || 'black'
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}
}

})